function loadJQuery(callback) {
  const jqueryCdn = 'https://code.jquery.com/jquery-3.6.0.min.js';
  const script = document.createElement('script');
  script.src = jqueryCdn;
  script.onload = callback;
  document.head.appendChild(script);
}

//footer navigation toggle
loadJQuery(function () {
  $('.footer__menu--header').on('click', function (event) {
    var element = $(".footer__menu--header--accordion");
    var element1 = $(".footer__menu--child-links");

    if (element.hasClass("is-open")) {
      element.removeClass("is-open");
      element1.css('display', 'none');
    } else {
      element.addClass("is-open");
      element1.css('display', 'block');
    }
  })
})

//mobile navigation toggle
loadJQuery(function () {
  $('.nav-mobile').on('click', function (event) {
    var element = $(".nav-drawer");

    if (element.hasClass("is-open")) {
      element.removeClass("is-open");
    } else {
      element.addClass("is-open");
    }
  })
})
